import { render } from "./CustomerTerms.vue?vue&type=template&id=2a4bf94e&scoped=true"
import script from "./CustomerTerms.vue?vue&type=script&lang=js"
export * from "./CustomerTerms.vue?vue&type=script&lang=js"

import "./CustomerTerms.vue?vue&type=style&index=0&id=2a4bf94e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4bf94e"]])

export default __exports__